import { map } from "lodash";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ModalGeneric from "../../Common/ModalGeneric";
import VedtakskoderForm from "../VedtakskoderForm";
import OpenModalComponent from "./OpenModalComponent";

import {
    addVedtakskodeIleggelseType,
    getVedtakskoder,
    postVedtakskoder,
} from "../../../actions/vedtakskoderAction";
import {
    IsValidated,
    onChangeValidation,
} from "../../../utils/validationUtils";

const rules = {
  id: "required;isDigit;minValue=1",
  kode: "required;minLength=2;maxLength=50",
  navn: "required;minLength=2;maxLength=50",
  klageKodeId: "required",
  deaktivertDato: "isDato",
};

const initState = {
  open: false,
  id: "",
  kode: "",
  navn: "",
  medhold: "",
  deaktivertDato: "",
  tilkemner: false,
  ileggelsestype: [],
  klageKodeId: 0,
  validationError: {},
  openDeaktiverConfirm: false,
};

function VedtakskodeModal() {
  const dispatch = useDispatch();
  const ileggelsestyper = useSelector((state) => state.ileggelsestyper);
  const klagekoder = useSelector((state) => state.klagekoder);

  const [state, setState] = useState(initState);
  const update = (patch) => setState((s) => ({ ...s, ...patch }));

  const closeModal = () => setState(initState);
  const openModal = () => update({ open: true });

  const isValid = () => {
    const { isValid, validationError } = IsValidated(state, rules);
    update({ validationError });
    return isValid;
  };

  const handlePost = async () => {
    update({ submitButtonText: "Lagrer..." });

    const payload = {
      id: state.id && Number(state.id),
      kode: state.kode,
      navn: state.navn,
      deaktivertDato: state.deaktivertDato || null,
      klageKodeId: state.klageKodeId && Number(state.klageKodeId),
    };

    await dispatch(postVedtakskoder(payload));
    await Promise.all(
      map(state.ileggelsestype, async (ileggelseTypeId) => {
        await dispatch(addVedtakskodeIleggelseType(state.id, ileggelseTypeId));
      })
    );
    await dispatch(getVedtakskoder());
    closeModal();
  };

  const saveAndClose = async () => {
    if (isValid() && !state.deaktivertDato) {
      await handlePost();
    } else if (isValid() && state.deaktivertDato) {
      update({ open: false, openDeaktiverConfirm: true });
    }
  };

  const handleChange = (e) => {
    const draft = { ...state, [e.target.name]: e.target.value };
    onChangeValidation(e, draft, rules);
    setState(draft);
  };

  return (
    <>
      <ModalGeneric
        modalTitle="Legg til ny vedtakskode"
        open={state.open}
        closeModal={closeModal}
        openModal={openModal}
        OpenModalComponent={OpenModalComponent}
        submit={saveAndClose}
        submitButtonText="Lagre"
      >
        <VedtakskoderForm
          id={state.id}
          kode={state.kode}
          navn={state.navn}
          deaktivertDato={state.deaktivertDato}
          tilkemner={state.tilkemner}
          klageKodeId={state.klageKodeId}
          klagekoder={klagekoder}
          ileggelsestyper={ileggelsestyper}
          ileggelsestype={state.ileggelsestype}
          handleChange={handleChange}
          validationError={state.validationError}
        />
      </ModalGeneric>
      <ModalGeneric
        modalTitle="Deaktiver vedtakskode"
        open={state.openDeaktiverConfirm}
        closeModal={() => update({ openDeaktiverConfirm: false, open: true })}
        submit={handlePost}
        submitButtonText={state.submitButtonText}
      >
        <p>Vil du deaktivere vedtakskode {state.id}?</p>
      </ModalGeneric>
    </>
  );
}

export default VedtakskodeModal;
